export default __webpack_public_path__ + "static/media/NOIZ3.0.5add8513.mp4";